import { withRouter } from "react-router";
import { connect } from "react-redux";
import styles from "./css/CourseButton.module.css";
import React from "react";
import { withTranslation } from "react-i18next";
import { createPaymentCourse } from "../../../redux/actions/payment";
import { buyCourse } from "../../../redux/actions/courses";
import { COUPONS_API, COUPON_VALIDATE_API } from "../../../redux/constants/apis";
import axios from "axios";
import { store } from "../../../redux/store"; 
import {
  CircularProgress,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputBase,
  Typography,
} from "@mui/material";
import ShareModal from "../../../components/shareModal/ShareModal";
import Modal from "../../../components/commons/Modal";
import { FaLock } from "react-icons/fa";
import { FaCheckCircle } from "react-icons/fa";

const USD_TO_INR = 85;

class CoursePayment extends React.Component {
  t = (key) => this.props.t(key);
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      showShareModal: false,
      showQrModal: false,
      qrCountry: "IN",
      link: window.location.href,
      attemptedPayment: false,
      purchaseRecorded: false,
      showEnrollMessageModal: false,
      delayedEnrollTimeout: null,
      couponCode: "",
      enrollMessageType: null,
      isApplying: false,
      appliedCoupon: null,
      coupons: [],
      selectedCouponCode: "",
      couponValidationMessage: null,
      enrollErrorMessage: null,
    };

    this.QR_MAP = {
      US: [`/Image/CourseMonetisation/payment-qr-us.png`],
      IN: [`/Image/CourseMonetisation/payment-qr-in.png`],
    };
  }

  componentWillUnmount() {
    if (this.state.delayedEnrollTimeout) clearTimeout(this.state.delayedEnrollTimeout);
  }

  getAuthHeader = () => {
    const token = store.getState()?.profile?.user?.token;
    return token ? { Authorization: `Token ${token}` } : {};
  };

  fetchCoupons = async () => {
    try {
      const headers = this.getAuthHeader();
      const res = await axios.get(COUPONS_API, { headers });
      const coupons = res?.data?.data || [];
      this.setState({ coupons });
    } catch (err) {
      console.warn("Failed to fetch coupons:", err);
    }
  };

  validateCoupon = async (code) => {
    try {
      const headers = this.getAuthHeader();
      const form = new FormData();
      form.append("code", code);
      const res = await axios.post(COUPON_VALIDATE_API, form, { headers });
      return res?.data?.data?.coupon || null;
    } catch (err) {
      console.warn("Coupon validation API error", err);
      return null;
    }
  };

  computeCouponDiscountUSD = (coupon, payableUSD) => {
    if (!coupon || !payableUSD || payableUSD <= 0) return 0;
    const type = coupon.discount_type;
    const val = Number(coupon.discount_value || 0);
    const maxCap = Number(coupon.max_discount_amount || 0);
    const minOrder = Number(coupon.min_order_amount || 0);

    if (minOrder > 0 && payableUSD < minOrder) {
      return { amount: 0, eligible: false, reason: "Minimum order amount not met" };
    }

    let amount = 0;
    if (type === "PERCENTAGE") {
      amount = (payableUSD * val) / 100;
      if (maxCap > 0) amount = Math.min(amount, maxCap);
    } else if (type === "FLAT") {
      amount = val;
      if (maxCap > 0) amount = Math.min(amount, maxCap);
    } else {
      amount = 0;
    }

    return { amount: Number(amount.toFixed(2)), eligible: true, reason: null };
  };

  formatCurrency = (amountUSD, qrCountry) => {
    if (amountUSD == null || isNaN(Number(amountUSD))) return "";
    const amt = Number(amountUSD);
    if (qrCountry === "IN") {
      const inr = Math.round(amt * USD_TO_INR);
      return `₹${inr}`;
    }
    // default USD
    return `$${Math.round(amt)}`;
  };

  shareModalOpener = (link) => this.setState({ showShareModal: true, link });
  shareModalCloser = () => this.setState({ showShareModal: false });
  shareCode = () => this.shareModalOpener();

  startLearning = (courseId) => {
    this.setState({ showEnrollMessageModal: false, enrollMessageType: null }, () => {
      const id =
        courseId || this.props.data?.id || (this.props.data && this.props.data.courseId) || "";
      const url = `/course/stream/${id}`;
      try {
        window.open(url, "_blank", "noopener,noreferrer");
      } catch (err) {
        window.location.href = url;
      }
    });
  };

  handleButtonClick = async () => {
    this.setState({ isLoading: true });
    const { currentCourse } = this.props;
    const price = Number(currentCourse?.price ?? this.props.data?.price ?? 0); // USD
    const courseId = this.props.data?.courseId;
    const course = currentCourse || {};

    if (price === 0) {
      try {
        // create payment (free)
        await this.props.createPaymentCourse(courseId, 0);
      } catch (err) {
        console.warn("createPaymentCourse (free) failed:", err);
      }

      try {
        await this.props.buyCourse(true, courseId, this.props.paymentCreated?.options_order_id, true);
        this.setState({
          purchaseRecorded: true,
          showEnrollMessageModal: true,
          enrollMessageType: "free",
          isLoading: false,
          enrollErrorMessage: null,
        });
      } catch (e) {
        console.error("buyCourse failed (free):", e);
        this.setState({
          isLoading: false,
          enrollErrorMessage: "Failed to record enrollment. Please try again or contact support.",
        });
      }
      return;
    }

    // Paid course: do NOT call createPaymentCourse or purchaseCourse here.
    this.setState({ attemptedPayment: true });

    const directPaymentLink =
      course?.payment_link ||
      course?.paymentLink ||
      course?.payment_url ||
      course?.course_payment_link ||
      null;

    if (directPaymentLink) {
      // Open the direct payment link (we will not call backend purchase APIs here).
      try {
        window.open(directPaymentLink, "_blank", "noopener,noreferrer");
      } catch (err) {
        window.location.href = directPaymentLink;
      }

      // Let user complete payment in new tab; show QR/modal only if coupons are available or for consistency
      try {
        await this.fetchCoupons();
      } catch (e) {
        console.warn("coupon fetch error", e);
      } finally {
        this.setState({ showQrModal: true, isLoading: false });
      }

      return;
    }

    try {
      await this.fetchCoupons();
    } catch (e) {
      console.warn("coupon fetch error", e);
    } finally {
      this.setState({ showQrModal: true, isLoading: false });
    }
  };

  handleCouponSelect = (e) => {
    const code = e.target.value || "";
    this.setState({ selectedCouponCode: code, couponValidationMessage: null, appliedCoupon: null });
  };

  handleCouponChange = (e) => {
    this.setState({ couponCode: e.target.value });
  };

  applyCoupon = async () => {
    const codeFromSelect = this.state.selectedCouponCode;
    const manual = (this.state.couponCode || "").trim();
    const code = codeFromSelect || manual;
    if (!code) return;

    this.setState({ isApplying: true, couponValidationMessage: null });

    try {
      const coupon = await this.validateCoupon(code);
      if (!coupon) {
        this.setState({ couponValidationMessage: "Invalid coupon code", isApplying: false });
        return;
      }

      const priceNumber = Number(this.props.data?.price);
      const discountedPriceNumber = Number(this.props.data?.discountedPrice) || 0;
      const payableUSD =
        discountedPriceNumber > 0 && discountedPriceNumber < priceNumber
          ? discountedPriceNumber
          : priceNumber;

      const computed = this.computeCouponDiscountUSD(coupon, payableUSD);
      if (!computed.eligible) {
        this.setState({ couponValidationMessage: computed.reason, isApplying: false });
        return;
      }

      this.setState({
        appliedCoupon: coupon,
        couponCode: code,
        couponValidationMessage: null,
        isApplying: false,
      });
    } catch (err) {
      console.error("Coupon validation failed", err);
      this.setState({ couponValidationMessage: "Failed to validate coupon. Try again.", isApplying: false });
    }
  };

  handleRemoveCoupon = () => {
    this.setState({ appliedCoupon: null, couponCode: "", selectedCouponCode: "" });
  };

  handleProceedAfterPayment = async () => {
    const { currentCourse } = this.props;
    const course = currentCourse || {};
    const courseId = course?.id || this.props.data?.courseId;

    if (!courseId || this.state.purchaseRecorded) {
      this.setState({ showQrModal: false, showEnrollMessageModal: true, enrollMessageType: "paid" });
      return;
    }

    this.setState({ isLoading: true, enrollErrorMessage: null });

    try {
      const priceNumber = Number(this.props.data?.price) || 0;
      const discountedPriceNumber = Number(this.props.data?.discountedPrice) || 0; 
      const payableUSD =
        discountedPriceNumber > 0 && discountedPriceNumber < priceNumber
          ? discountedPriceNumber
          : priceNumber;

      const coupon = this.state.appliedCoupon || null;

      let couponDiscountUSD = 0;
      if (coupon) {
        const cmp = this.computeCouponDiscountUSD(coupon, payableUSD);
        if (cmp && cmp.eligible) couponDiscountUSD = Number(cmp.amount) || 0;
        else couponDiscountUSD = 0;
      }

      const finalAmountUSD = Math.max(0, Number((payableUSD - couponDiscountUSD).toFixed(2)));

      const userData = JSON.parse(localStorage.getItem("userData") || "null");
      const profileId = userData?.profile_id || null;

      const payload = {
        course: courseId,
        couponCodeId: coupon ? coupon.id : null,
        baseAmount: Number(payableUSD), // amount after creator discount
        discountedAmount: Number(finalAmountUSD), // amount after creator + coupon
        price: Number(priceNumber), // original price before any discount
        profile: profileId,
      };

      const headers = { ...this.getAuthHeader(), "Content-Type": "application/json" };

      const url = `${process.env.REACT_APP_API_BASE_URL}api/v1/course-purchases/`;
      await axios.post(url, payload, { headers });

      this.setState({
        isLoading: false,
        purchaseRecorded: true,
        showQrModal: false,
        showEnrollMessageModal: true,
        enrollMessageType: "paid",
        enrollErrorMessage: null,
      });
    } catch (err) {
      console.warn("Proceed after payment failed:", err);
      this.setState({
        isLoading: false,
        purchaseRecorded: false,
        enrollErrorMessage: "Failed to record payment. Please try again or contact support.",
      });
    }
  };

  handleQrCountryChange = (e) => {
    const value = e.target.value;
    this.setState({ qrCountry: value });
  };

  getQrImagesForCountry = (qrCountry) => {
    if (!qrCountry) qrCountry = "IN";
    const images = this.QR_MAP[qrCountry];
    if (images && images.length > 0) return images;
    return this.QR_MAP["IN"];
  };

  // render the QR modal content (with coupon dropdown + computed summary)
  renderQrCardContent = () => {
    const { currentCourse } = this.props;
    const { qrCountry, coupons, selectedCouponCode, appliedCoupon, couponValidationMessage } = this.state;
    const course = currentCourse || {};

    const qrImages = this.getQrImagesForCountry(qrCountry);

    const priceNumber = Number(this.props.data?.price) || 0;
    const discountedPriceNumber = Number(this.props.data?.discountedPrice) || 0;
    const currencySymbol = qrCountry === "US" ? "$" : "₹";

    const discountPercentage =
      discountedPriceNumber > 0 && discountedPriceNumber < priceNumber
        ? Math.floor(((priceNumber - discountedPriceNumber) / priceNumber) * 100)
        : 0;

    const payableUSD =
      discountedPriceNumber > 0 && discountedPriceNumber < priceNumber ? discountedPriceNumber : priceNumber;

    let couponDiscountUSD = 0;
    let couponEligible = true;
    if (appliedCoupon) {
      const cmp = this.computeCouponDiscountUSD(appliedCoupon, payableUSD);
      couponDiscountUSD = cmp && cmp.eligible ? Number(cmp.amount) : 0;
      couponEligible = cmp ? cmp.eligible : true;
    }

    const finalAmountUSD = Math.max(0, Number((payableUSD - couponDiscountUSD).toFixed(2)));

    const displayPrice = qrCountry === "US" ? priceNumber : Number((priceNumber * USD_TO_INR).toFixed(2));
    const displayDiscountAmount = qrCountry === "US"
      ? Number((priceNumber - discountedPriceNumber).toFixed(2))
      : Number(((priceNumber - discountedPriceNumber) * USD_TO_INR).toFixed(2));
    const displayCouponDiscount = qrCountry === "US"
      ? Number(couponDiscountUSD.toFixed(2))
      : Number((couponDiscountUSD * USD_TO_INR).toFixed(2));
    const finalTotalDisplay = qrCountry === "US"
      ? finalAmountUSD
      : Number((finalAmountUSD * USD_TO_INR).toFixed(2));

    const fmt = (x) => (isNaN(Number(x)) ? "" : Number(x).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));

    const formattedPrice = `${currencySymbol}${fmt(displayPrice)}`;
    const formattedDiscountedPrice = `${currencySymbol}${fmt(displayDiscountAmount)}`;
    const formattedCouponDiscount = `${currencySymbol}${fmt(displayCouponDiscount)}`;
    const formattedTotal = `${currencySymbol}${fmt(finalTotalDisplay)}`;

    return (
      <div
        style={{
          width: 872,
          maxWidth: "872px",
          height: 668,
          maxHeight: "668px",
          borderRadius: 10,
          background: "#fff",
          position: "relative",
          overflow: "hidden",
          boxShadow: "0 12px 40px rgba(0,0,0,0.08)",
          borderTop: `4px solid #EE2D73`,
          borderBottom: `4px solid #EE2D73`,
        }}
      >
        <div style={{ display: "flex", gap: 18, padding: "0 25px 17px 29px" }}>
          <div style={{ flex: 1 }}>
            {/* LEFT (country + QR) */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 18 }}>
              <div style={{ flex: 1, minWidth: 0, padding: "20px 0 0 0" }}>
                <Typography variant="h6" sx={{ fontSize: 20, fontWeight: 700 }}>
                  {this.t("payment.country")}
                </Typography>
                <div style={{ marginTop: 12 }}>
                  <FormControl
                    size="small"
                    sx={{
                      width: "100%",
                      border: "1px solid #858585",
                      borderRadius: "8px",
                      bgcolor: "transparent",
                      height: 50,
                      display: "flex",
                      justifyContent: "center",
                      fontSize: 18,
                      pl: "9px",
                      pt: "5px",
                    }}
                  >
                    <Select
                      value={qrCountry}
                      onChange={this.handleQrCountryChange}
                      displayEmpty
                      input={<InputBase />}
                      sx={{
                        pl: 1,
                        pr: 1,
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        fontSize: 18,
                      }}
                    >
                      <MenuItem value="US">
                        <div style={{ display: "flex", alignItems: "center", gap: 16, fontSize: 18 }}>
                          <img src="/Image/CourseMonetisation/flag-usa-icon.png" alt="US" style={{ width: 30, height: 20 }} />
                          US
                        </div>
                      </MenuItem>
                      <MenuItem value="IN">
                        <div style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 18 }}>
                          <img src="/Image/CourseMonetisation/flag-india-icon.png" alt="IN" style={{ width: 30, height: 20 }} />
                          India
                        </div>
                      </MenuItem>
                    </Select>
                  </FormControl>
                </div>

                <div style={{ marginTop: 18 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                    <Typography variant="h6" sx={{ fontSize: 20, fontWeight: 700 }}>
                      {this.t("payment.payment")}
                    </Typography>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, color: "#5E6C73", fontSize: 12, fontWeight: 500 }}>
                      <img style={{ width: 12, height: 13, paddingBottom: 2 }} src="/Image/CourseMonetisation/lock-icon.svg" alt="" />
                      <div>{this.t("payment.securedEncrypted")}</div>
                    </div>
                  </div>

                  <div style={{ border: "1px solid #000000", borderRadius: 8, padding: 8, display: "flex", justifyContent: "center", alignItems: "center" }}>
                    {qrImages && qrImages.length > 0 ? (
                      <img
                        src={qrImages[0]}
                        alt="QR"
                        style={{ maxWidth: "406px", maxHeight: 406, objectFit: "contain" }}
                        onError={(e) => {
                          console.warn("QR load error", e.target.src);
                          e.target.style.border = "2px dashed red";
                        }}
                      />
                    ) : (
                      <div style={{ height: 360, display: "flex", alignItems: "center", justifyContent: "center", color: "#6b7280" }}>
                        No QR available
                      </div>
                    )}
                  </div>

                  <div style={{ marginTop: 15, color: "#84949E", fontSize: 12, fontWeight: 500 }}>
                    {this.t("payment.facingIssues")} <a href="/support" style={{ color: "#f33070" }}>{this.t("payment.contactSupport")}</a>
                  </div>
                </div>
              </div>

              {/* RIGHT PANEL */}
              <div style={{ textAlign: "left", flex: 1, minWidth: 0, position: "relative", paddingBottom: 56 }}>
                <div style={{ background: "#ffeded", borderBottomLeftRadius: 10, borderBottomRightRadius: 10, padding: 16 }}>
                  <Typography variant="h6" sx={{ fontSize: 20, fontWeight: 700, marginBottom: 1, color: "#121212" }}>
                    {this.t("payment.orderDetails")}
                  </Typography>

                  <div style={{ display: "flex", alignItems: "center", gap: 12, justifyContent: "space-between", marginTop: 18, marginBottom: 12 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 0, flex: 1 }}>
                      <div style={{ width: 34, height: 34, borderRadius: 8, background: "#f33070", display: "flex", justifyContent: "center", alignItems: "center", flexShrink: 0 }}>
                        <img style={{ height: "20px", width: "20px" }} src={`/Image/assignment/White/Assignment.svg`} alt=" " />
                      </div>
                      <div
                        style={{
                          fontWeight: 400,
                          overflow: "hidden",
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          textOverflow: "ellipsis",
                          lineHeight: "1.2em",
                          fontSize: 16,
                          maxHeight: "2.4em",
                        }}
                      >
                        {course?.name}
                      </div>
                    </div>
                    <div style={{ color: "#000000", fontWeight: 500, fontSize: 16 }}>{formattedPrice}</div>
                  </div>

                  {/* Coupon row: show dropdown if coupons exist, else show input */}
                  <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 8 }}>
                    <div
                      style={{
                        flex: 1,
                        borderRadius: 10,
                        border: "1px solid #858585",
                        height: 50,
                        display: "flex",
                        alignItems: "center",
                        padding: "0 10px",
                      }}
                    >
                      {appliedCoupon ? (
                        <div
                          role="status"
                          aria-live="polite"
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 8,
                            padding: "8px 10px",
                            borderRadius: "10px",
                            background: "#FFD3D3",
                            fontWeight: 400,
                            fontSize: 18,
                            color: "#111827",
                            minWidth: 0,
                            width: "fit-content",
                            flexShrink: 0, 
                            height: 34,
                            margin: 7,
                          }}
                        >
                          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            <span style={{ marginLeft: 6, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                              {appliedCoupon.code}
                            </span>
                          </div>

                          <button
                            aria-label={`Remove coupon ${appliedCoupon.code}`}
                            onClick={this.handleRemoveCoupon}
                            style={{
                              marginLeft: "auto",
                              border: "none",
                              background: "transparent",
                              cursor: "pointer",
                              padding: 6,
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: 18,
                            }}
                          >
                            <img src="/Image/CourseMonetisation/close-icon.png" alt="Remove" style={{ width: 18, height: 18 }} />
                          </button>
                        </div>
                      ) : (
                        <>
                          {coupons && coupons.length > 0 ? (
                            <Select
                              value={selectedCouponCode}
                              onChange={this.handleCouponSelect}
                              displayEmpty
                              sx={{ width: "100%", height: 50, fontSize: 16 }}
                              input={<InputBase />}
                            >
                              <MenuItem value="">
                                {this.t("payment.couponCode")}
                              </MenuItem>
                              {coupons.map((c) => {
                                // compute eligibility per coupon (payableUSD is defined above)
                                const cmp = this.computeCouponDiscountUSD(c, payableUSD);
                                // also check active / date validity quickly
                                const now = new Date();
                                const validFrom = c.valid_from ? new Date(c.valid_from) : null;
                                const validTo = c.valid_to ? new Date(c.valid_to) : null;
                                const active = c.is_active && (!validFrom || now >= validFrom) && (!validTo || now <= validTo);
                                const disabled = !active || !cmp.eligible;

                                return (
                                  <MenuItem key={c.id} value={c.code} disabled={disabled} title={disabled ? (active ? cmp.reason : "Coupon inactive/expired") : ""}>
                                    {c.code} {c.discount_type === "PERCENTAGE" ? `(${c.discount_value}% off)` : `(${c.discount_value} USD off)`} {disabled ? " — not applicable" : ""}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          ) : (
                            // fallback to simple input if no coupons fetched
                            <input
                              value={this.state.couponCode}
                              onChange={this.handleCouponChange}
                              placeholder="Coupon code"
                              aria-label="Coupon code"
                              style={{
                                flex: 1,
                                padding: "10px 12px",
                                borderRadius: 10,
                                border: "none",
                                fontWeight: 500,
                                outline: "none",
                                fontSize: 18,
                                height: 50,
                                background: "transparent",
                                placeholderFontSize: 18,
                              }}
                            />
                          )}
                        </>
                      )}
                    </div>

                    <button
                      onClick={this.applyCoupon}
                      disabled={this.state.isApplying || appliedCoupon}
                      style={{
                        padding: "10px 16px",
                        borderRadius: 10,
                        background: appliedCoupon ? "#DFDFDF" : "#ffd3d3",
                        border: "none",
                        fontWeight: 400,
                        cursor: this.state.isApplying ? "wait" : "pointer",
                        minWidth: 90,
                        fontSize: 18,
                        height: 50,
                      }}
                      aria-label="Apply coupon"
                    >
                      {this.state.isApplying ? this.t("payment.applying") : this.t("payment.apply")}
                    </button>
                  </div>

                  {couponValidationMessage && (
                    <div style={{ color: "crimson", marginTop: 8 }}>{couponValidationMessage}</div>
                  )}
                  {this.state.enrollErrorMessage && (
                    <div style={{ color: "crimson", marginTop: 8 }}>{this.state.enrollErrorMessage}</div>
                  )}

                  <div style={{ marginTop: 12, padding: 0 }}>
                    <Typography variant="h6" sx={{ fontSize: 20, fontWeight: 700, marginBottom: 1 }}>
                      {this.t("payment.orderSummary")}
                    </Typography>

                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <div style={{ color: "#3C3C3C", fontWeight: 400, fontSize: 16 }}>{this.t("payment.originalPrice")}</div>
                      <div style={{ color: "#000000", fontWeight: 500, fontSize: 16 }}>{formattedPrice}</div>
                    </div>

                    {discountedPriceNumber > 0 && discountedPriceNumber < priceNumber && (
                      <>
                        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 4 }}>
                          <div style={{ color: "#3C3C3C", fontWeight: 400, fontSize: 16 }}>{this.t("payment.discounts")} ({discountPercentage}% {this.t("payment.off")}):</div>
                          <div style={{ color: "#000000", fontWeight: 500, fontSize: 16 }}>-{formattedDiscountedPrice}</div>
                        </div>
                      </>
                    )}

                    {/* coupon discount row */}
                    {appliedCoupon && couponDiscountUSD > 0 && (
                      <div style={{ display: "flex", justifyContent: "space-between", marginTop: 4 }}>
                        <div style={{ color: "#3C3C3C", fontWeight: 400, fontSize: 16 }}>
                          {appliedCoupon.code} Applied (
                          {appliedCoupon.discount_type === "PERCENTAGE"
                            ? `${appliedCoupon.discount_value}%`
                            : `${this.formatCurrency(appliedCoupon.discount_value, qrCountry)} off`}
                          ):
                        </div>
                        <div style={{ color: "#000000", fontWeight: 500, fontSize: 16 }}>-{formattedCouponDiscount}</div>
                      </div>
                    )}

                    <hr style={{ marginTop: 12, marginBottom: 12, border: 0, borderTop: "2px solid #5e5e5e" }} />

                    <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 700, fontSize: 16, color: "#121212" }}>
                      <div>{this.t("payment.total")}</div>
                      <div>{formattedTotal}</div>
                    </div>

                    <div style={{ marginTop: 10, color: "#84949E", fontSize: 12 }}>
                      {this.t("payment.termsPrefix")} <span style={{ color: "#f33070", fontWeight: 600 }}>{this.t("payment.termsAndConditions")}</span>.
                    </div>

                    <div style={{ marginTop: 12 }}>
                      <button onClick={this.handleProceedAfterPayment} style={{ width: "100%", fontSize: 16, height: 36, borderRadius: 8, background: "#ff2d72", color: "white", border: "none", fontWeight: 500, cursor: "pointer" }}>
                        <img style={{ width: 14, height: 15, paddingBottom: 2, marginRight: 4 }} src="/Image/CourseMonetisation/lock-icon-proceed.svg" alt="" /> <span>{this.t("payment.proceed")}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <button onClick={() => this.setState({ showQrModal: false })} style={{ border: "1px solid #F33070", fontSize: 16, fontWeight: 600, color: "#F33070", background: "transparent", padding: "6px 16px", borderRadius: 5, cursor: "pointer", position: "absolute", bottom: 16, right: 16 }}>
            Cancel
          </button>
        </div>
      </div>
    );
  };

  renderEnrollMessageCard = () => {
    const accentPink = "#F33070";
    const isMobile = window.innerWidth < 480;
    const { enrollMessageType } = this.state;
    const { currentCourse } = this.props;
    const course = currentCourse || {};
    const courseId = course?.id || this.props.data?.courseId;

    if (enrollMessageType === "free") {
      const illustrationUrl = "/Image/CourseMonetisation/Welcome-illustration.svg";
      return (
        <div role="dialog" aria-modal="true" aria-labelledby="enroll-title" style={{ width: isMobile ? "auto" : 560, maxWidth: "calc(100vw - 64px)", height: isMobile ? "auto" : 560, borderRadius: 12, background: "#ffffff", padding: isMobile ? "20px 16px 22px" : "38px 80px", boxSizing: "border-box", boxShadow: "0 12px 36px rgba(16,24,40,0.16)", textAlign: "center", position: "relative", borderTop: `6px solid #EE2D73`, borderBottom: `6px solid #EE2D73`, overflow: "visible", fontFamily: "Lato" }}>
          <button aria-label="Close" onClick={() => this.setState({ showEnrollMessageModal: false, enrollMessageType: null })} style={{ position: "absolute", right: 12, top: 14, width: 34, height: 34, background: "#fff", border: "none", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", padding: 0 }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M18 6L6 18M6 6l12 12" stroke={accentPink} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>

          <div style={{ marginTop: 6, marginBottom: 6, display: "flex", justifyContent: "center" }} aria-hidden="true">
            <img src={illustrationUrl} alt="" style={{ width: isMobile ? "76%" : 380, height: "auto", objectFit: "contain", display: "block", borderRadius: 8 }} />
          </div>

          <p id="enroll-title" style={{ marginTop: "28px", fontSize: 18, fontWeight: 400, color: "#7A7A7A", marginBottom: 4 }}>
             {this.t("payment.welcomeToCourse")}{" "}
            <span style={{ fontWeight: 700 }}>{course?.name || "course name"}</span>.
          </p>

          <p style={{ margin: 0, fontSize: 18, color: "#7A7A7A", fontWeight: 400, maxWidth: 320, marginLeft: "auto", marginRight: "auto" }}>
            {this.t("payment.accessMaterials")}
          </p>

          <div style={{ marginTop: 20, display: "flex", justifyContent: "center" }}>
            <button onClick={() => this.startLearning(courseId)} aria-label="Start Learning" style={{ fontFamily: "Lato", padding: "10px 25px 10px 25px", height: 44, borderRadius: 44, background: "#EE2D73", color: "#fff", border: "none", fontWeight: 700, fontSize: 16, cursor: "pointer", textTransform: "none" }}>
              {this.t("payment.startLearning")}
            </button>
          </div>
        </div>
      );
    }

    return (
      <div style={{ width: isMobile ? "auto" : 380, maxWidth: "calc(100vw - 64px)", borderRadius: 12, background: "#ffffff", padding: "52px 24px 24px 24px", boxSizing: "border-box", boxShadow: "0 12px 36px rgba(16,24,40,0.16)", textAlign: "center", position: "relative" }}>
        <div style={{ width: 64, height: 64, borderRadius: "50%", background: accentPink, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto", transform: "translateY(-32px)" }} aria-hidden="true">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Success">
            <path d="M20 6L9 17l-5-5" stroke="#ffffff" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>

        <div style={{ marginTop: -28, paddingTop: 6 }}>
          <h2 style={{ margin: "6px 0 4px 0", fontSize: 18, fontWeight: 600, color: "#111827" }}>{this.t("payment.thankYou")}</h2>

          <div style={{ fontSize: 13, fontWeight: 400, color: "#000000", lineHeight: 1.3, marginTop: 6 }}>
            {this.t("payment.enrollLine1")} <br />
            {this.t("payment.enrollLine2")}
          </div>

          <div style={{ marginTop: 18 }}>
            <button onClick={() => this.setState({ showEnrollMessageModal: false, enrollMessageType: null })} style={{ display: "inline-block", padding: "10px 28px", borderRadius: 12, background: accentPink, color: "#fff", border: "none", fontWeight: 700, fontSize: 14, cursor: "pointer", textTransform: "none", minWidth: 160 }} aria-label="Ok, Got it">
              {this.t("payment.okGotIt")}
            </button>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { isLoading, showShareModal, link, showQrModal, showEnrollMessageModal } = this.state;
    const { currentCourse } = this.props;
    return (
      <>
        <ShareModal closeModal={this.shareModalCloser} show={showShareModal} link={link} id={this.props.data?.id} coursePage={true} />

        {showQrModal && <Modal card={this.renderQrCardContent()} />}

        {showEnrollMessageModal && <Modal card={this.renderEnrollMessageCard()} />}

        <button
          className={`${styles.actionBtn} ${currentCourse?.is_enrolled ? styles.Outlined : ""}`}
          style={!currentCourse?.active ? { opacity: "0.4", cursor: "not-allowed" } : null}
          onClick={
            currentCourse?.active && this.props.data?.enroll
              ? this.handleButtonClick
              : currentCourse?.is_enrolled
              ? this.shareCode
              : null
          }
          aria-disabled={!currentCourse?.active}
        >
          {isLoading ? <CircularProgress sx={{ color: "white" }} size={15} /> : (
            <div>
              <div>{this.props.data?.btnText}</div>
              {!currentCourse?.is_enrolled &&
                <div className={styles.startsOn}>{this.props.data?.startsOn}</div>
              }
            </div>
          )}
        </button>
      </>
    );
  }
}

const mapStateToProps = (state) => ({ paymentCreated: state?.courses?.paymentCreated, currentCourse: state?.courses?.currentCourse });
const mapDispatchToProps = (dispatch) => ({
  createPaymentCourse: (id, amount) => dispatch(createPaymentCourse(id, amount)),
  buyCourse: (isSuccess, id, data, free) => dispatch(buyCourse(isSuccess, id, data, free)),
});

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(withRouter(CoursePayment)));



// Old code below (Razorpay integration - deprecated)

// import { withRouter } from "react-router";
// import { connect } from "react-redux";
// import styles from "./css/CourseButton.module.css";
// import React, { useEffect } from "react";
// import { withTranslation } from "react-i18next";
// import { createPaymentCourse } from "../../../redux/actions/payment";
// import { buyCourse } from "../../../redux/actions/courses";
// import { CircularProgress } from "@mui/material";
// import ShareModal from "../../../components/shareModal/ShareModal";

// class CoursePayment extends React.Component {
//   // this is a button which can do payment, share

//   constructor(props) {
//     super(props);
//     this.state = {
//       isLoading: false,
//       showShareModal: false,
//       link: window.location.href,
//     };
//   }

//   componentDidMount() {
//     const script = document.createElement("script");
//     script.src = "https://checkout.razorpay.com/v1/checkout.js";
//     script.async = true;
//     document.body.appendChild(script);
//   }

//   setAsyncState = (newState) =>
//     new Promise((resolve) => this.setState(newState, resolve));

//   shareModalOpener = (link) => {
//     this.setState({ showShareModal: true, link: link });
//   };

//   shareModalCloser = () => {
//     this.setState({ showShareModal: false });
//   };

//   shareCode = () => {
//     this.shareModalOpener();
//   };

//   handleShare = () => {};

//   openPayModal() {
//     // this.setState({isLoading:false})

//     if (this.props?.data?.price === 0) {
//       this.props
//         .buyCourse(
//           true,
//           this.props.data.courseId,
//           this.props.paymentCreated?.options_order_id,
//           true
//         )
//         .then(() => {
//           this.setState({ isLoading: false });
//         });
//     } else {
//       // console.log("open modal is called");

//       // var amount = amt * 100; //Razorpay consider the amount in paise
//       // console.log("modal data =", this.props.paymentCreated)
//       // console.log(p?.courses?.paymentCreated?.options_name)

//       var options = {
//         key: `${process.env.REACT_APP_RAZORPAY_KEY}`,
//         // amount: this.props?.currentCourse?.price, // 2000 paise = INR 20, amount in paisa
//         amount: 200,
//         name: this.props.paymentCreated?.options_name,
//         description: this.props.paymentCreated?.options_description,
//         order_id: this.props.paymentCreated?.options_order_id,
//         image: this.props.paymentCreated?.options_image,
//         handler: (response) => {
//           var values = {
//             razorpay_signature: response.razorpay_signature,
//             razorpay_order_id: response.razorpay_order_id,
//             razorpay_payment_id: response.razorpay_payment_id,
//             // transactionamount : amount,
//           };
//           this.props
//             .buyCourse(true, this.props?.data?.courseId, values, false)
//             .then(() => {
//               this.setState({ isLoading: false });
//             });
//         },
//         prefill: {
//           name: this.props.paymentCreated?.prefill_name,
//           email: this.props.paymentCreated?.prefill_email,
//           //   "contact":'1234567890',
//         },
//         notes: {
//           address: this.props.paymentCreated?.notes_address,
//         },
//         theme: {
//           color: "#F33070",
//         },
//         modal: {
//           ondismiss: () => {
//             this.setState({ isLoading: false });
//           },
//         },
//       };

//       var rzp1 = new window.Razorpay(options);
//       rzp1.on("payment.failed", (response) => {
//         var data = {
//           order_id: response.error.metadata.order_id,
//           payment_id: response.error.metadata.payment_id,
//           code: response.error.code,
//           description: response.error.description,
//           reason: response.error.reason,
//           step: response.error.step,
//           source: response.error.source,
//         };
//         this.props.buyCourse(false, this.props.data.courseId, data, false);
//       });
//       rzp1.open();
//     }
//   }

//   render() {
//     return (
//       <>
//         <ShareModal
//           closeModal={this.shareModalCloser}
//           show={this.state.showShareModal}
//           link={window.location.href}
//           coursePage={true}
//         />
//         {
//           //  (this.props?.currentCourse?.is_enrolled && !this.props?.currentCourse?.free ? null :
//           <button
//             className={styles.actionBtn}
//             style={
//               !this.props.currentCourse?.active
//                 ? { opacity: "0.4", cursor: "not-allowed" }
//                 : null
//             }
//             // if the course is active and it can be enrolled then only do the functioning
//             onClick={
//               this.props.currentCourse?.active && this.props.data?.enroll
//                 ? () =>
//                     this.setAsyncState({ isLoading: true })
//                       .then(() =>
//                         this.props?.createPaymentCourse(
//                           this.props.data?.courseId,
//                           this.props.data?.price
//                         )
//                       )
//                       .then(() => this.openPayModal())
//                 : this.props?.currentCourse?.is_enrolled
//                 ? this.shareCode
//                 : null
//             }
//           >
//             {this.state.isLoading ? (
//               <CircularProgress sx={{ color: "white" }} size={15} />
//             ) : (
//               this.props.data?.btnText
//             )}
//           </button>
//           // )
//         }
//       </>
//     );
//   }
// }

// const mapStateToProps = (state) => {
//   return {
//     paymentCreated: state?.courses?.paymentCreated,
//     currentCourse: state?.courses?.currentCourse,
//   };
// };

// const mapDispatchToProps = (dispatch) => {
//   return {
//     createPaymentCourse: (id, amount) =>
//       dispatch(createPaymentCourse(id, amount)),
//     buyCourse: (isSuccess, id, data, free) =>
//       dispatch(buyCourse(isSuccess, id, data, free)),
//   };
// };

// export default withTranslation()(
//   connect(mapStateToProps, mapDispatchToProps)(withRouter(CoursePayment))
// );
